let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ip01M")).then(() => parcelRequire('f6p4x'));